import React from 'react';

const MobileOrg = props => (
  <svg data-name="Layer 1" viewBox="0 0 30 30" {...props}>
    <path d="M30 15H17V2a1 1 0 00-1-1H2a1 1 0 00-1 1v28a1 1 0 001 1h28a1 1 0 001-1V16a1 1 0 00-1-1zM3 3h12v26h-3v-4a1 1 0 00-1-1H7a1 1 0 00-1 1v4H3zm5 26v-3h2v3zm21 0H17V17h12zM7 7H5V5h2zm3 0H8V5h2zm3 0h-2V5h2zm-6 3H5V8h2zm3 0H8V8h2zm3 0h-2V8h2zm-6 3H5v-2h2zm3 0H8v-2h2zm3 0h-2v-2h2zm-6 3H5v-2h2zm3 0H8v-2h2zm3 0h-2v-2h2zm-6 3H5v-2h2zm3 0H8v-2h2zm3 0h-2v-2h2zm-6 3H5v-2h2zm3 0H8v-2h2zm3 0h-2v-2h2zm8-1h-2v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-6 3h-2v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-6 3h-2v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2z" />
  </svg>
);

export default MobileOrg;
